module.exports = __webpack_public_path__ + "static/media/Toilettenbuersten.461096a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Toilettenbuersten.png
// module id = 134
// module chunks = 0